export default class E2EMFController {
	/* @ngInject */
	constructor() {
		// classic
		this.mf1 = {
			model: [],
			disabled: false,
			required: true,
			order: 'K_NODE;FIRSTNAME',
			placeholder: 'mf 1',
		};

		this.mf2 = {
			model: [],
			disabled: true,
			required: true,
			order: 'K_NODE;FIRSTNAME',
			placeholder: 'mf 2',
		};

		this.mf3 = {
			model: [],
			disabled: false,
			required: true,
			order: 'K_NODE;FIRSTNAME',
			placeholder: 'mf 3',
		};

		this.mf4 = {
			model: [],
			disabled: false,
			required: true,
			order: 'K_NODE;FIRSTNAME',
			placeholder: 'mf 4',
		};

		this.$onInit();
	}

	$doCheck() {}

	$onInit() {}
}
